import * as go from 'gojs'
import { layoutGroupSpacing, layoutNodeSpacingAdjustmentForBadge, layoutHorizontalFudge } from '@/utils/constants'

export default function InlineLayout () {
  go.GridLayout.call(this)
  this.isViewportSized = false
}

go.Diagram.inherit(InlineLayout, go.GridLayout)

function completedCluster (cluster, spac) {
  let clusterArea = 0
  cluster.forEach(clusterPart => {
    const area = (clusterPart.actualBounds.width + spac.width) *
      (clusterPart.actualBounds.height + spac.height)
    clusterArea += area
  })
  const wrappingWidth = Math.sqrt(clusterArea)
  let rowWidth = 0
  const clusterTopLeft = cluster[0].position
  let y = clusterTopLeft.y
  let x = clusterTopLeft.x
  let height = cluster[0].actualBounds.height + layoutNodeSpacingAdjustmentForBadge
  const originalHeight = height
  let maxWidth = 0
  cluster.forEach(clusterPart => {
    if (x !== clusterTopLeft.x && rowWidth + clusterPart.actualBounds.width > wrappingWidth) {
      const yChange = clusterPart.actualBounds.height + layoutNodeSpacingAdjustmentForBadge + spac.height
      y += yChange
      height += yChange
      x = clusterTopLeft.x
      rowWidth = 0
    }
    clusterPart.moveTo(x, y)
    x += clusterPart.actualBounds.width + layoutHorizontalFudge
    rowWidth += clusterPart.actualBounds.width + spac.width
    if (rowWidth > maxWidth) {
      maxWidth = rowWidth
    }
  })
  return { parts: cluster, topLeft: clusterTopLeft, clusterHeight: height, clusterWidth: maxWidth, isCluster: true, originalHeight: originalHeight }
}

function getMaxClusterHeight (clusters) {
  let max = 0
  if (clusters) {
    clusters.forEach(cluster => {
      if (cluster.clusterHeight > max) {
        max = cluster.clusterHeight
      }
    })
  }
  return max
}

InlineLayout.prototype.doLayout = function (coll) {
  var ecoll = this.collectParts(coll)
  const parts = []
  ecoll.each(p => {
    parts.push(p)
  })
  parts.sort(this.comparer)
  const padding = this.group.placeholder.padding
  let topLeft = this.group.placeholder.getDocumentPoint(go.Spot.TopLeft)
  topLeft.x += padding.left
  topLeft.y += padding.top
  var spac = this.spacing
  let x = topLeft.x
  let rowHeight = 0
  parts.forEach(function (p) {
    if (p instanceof go.Link) return
    const itemHeight = p.actualBounds.height + layoutNodeSpacingAdjustmentForBadge
    if (itemHeight > rowHeight) {
      rowHeight = itemHeight
    }
  })
  parts.forEach(function (p) {
    if (p instanceof go.Link) return
    const itemHeight = p.actualBounds.height + layoutNodeSpacingAdjustmentForBadge
    let y = topLeft.y + (p.data.isGroup ? layoutGroupSpacing : 0) + (rowHeight - itemHeight) / 2
    p.moveTo(x, y)
    x += p.actualBounds.width + spac.width
  })

  // TODO put above in a file shared with HorizontalLayout

  // Look for clusters of nodes not in a group and square them up
  let clusters = []
  const partsWithClusters = []
  let cluster = []
  let i = 0
  if (parts && parts.length > 0) {
    while (i < parts.length) {
      let part = parts[i]
      if (part.data.isGroup || part.data.isOperator) {
        partsWithClusters.push(part)
        i++
      } else {
        while (true) {
          cluster.push(part)
          i++
          if (i >= parts.length) {
            break
          }
          part = parts[i]
          if (part.data.isGroup || part.data.isOperator) {
            break
          }
        }
        if (cluster.length === 1) {
          partsWithClusters.push(cluster[0])
        }
        if (cluster.length > 1) {
          const processedCluster = completedCluster(cluster, this.spacing)
          clusters.push(processedCluster)
          partsWithClusters.push(processedCluster)
        }
        cluster = []
      }
    }
  }
  if (clusters.length > 0) {
    const maxClusterHeight = getMaxClusterHeight(clusters)
    let x = topLeft.x
    const newRowHeight = Math.max(maxClusterHeight, rowHeight)
    partsWithClusters.forEach(p => {
      if (p.isCluster) {
        const yAdjustment = (rowHeight - p.originalHeight) / 2 - (newRowHeight - p.clusterHeight) / 2
        const xAdjustment = p.parts[0].position.x - x
        p.parts.forEach(clusterPart => {
          clusterPart.moveTo(clusterPart.position.x - xAdjustment, clusterPart.position.y - yAdjustment)
        })
        x += p.clusterWidth + layoutHorizontalFudge
      } else {
        const itemHeight = p.actualBounds.height + layoutNodeSpacingAdjustmentForBadge
        let y = topLeft.y + (p.data.isGroup ? layoutGroupSpacing : 0) + (newRowHeight - itemHeight) / 2
        p.moveTo(x, y)
        x += p.actualBounds.width + layoutHorizontalFudge
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/graph_parts/inline_layout.js